import { action } from 'satcheljs';

/**
 * Action which initialises the search store guid properties
 * If you need to initialise another guid property in the store please add that here
 */
export default action('initializeGuidsForSearchStore', function initializeGuidsForSearchStore() {
    return {};
});
